import classes from './Paragraph.module.scss'
import type { ReactNode } from 'react'

export interface Props {
  children: ReactNode
  variant?: '' |
  'text-overflow' |
  'word-break'|
  'whitespace-pre-wrap'
}

const Paragraph = ({
  children,
  variant = ''
}: Props) => (
  <p className={classes.Paragraph + ' ' + classes[variant]}>
    {children}
  </p>
)

export default Paragraph
